import React from 'react';
import {connect} from 'react-redux';
import Translator from "../../helpers/Translator";
import {DOMAIN} from "../FilterContainer";
import {bindActionCreators} from "redux";
import {clearFilter, returnAirportSelected} from "../../actions/FlightsActions";
import PriceFormatter from "../../helpers/PriceFormatter";
import {registerAppliedFilter} from "../../actions/FilterGroupsActions";
import BaseFilterComponent from "./BaseFilterComponent";

class ReturnAirportBlock extends BaseFilterComponent {
    constructor(props) {
        super(props);
        this.filter = 'returnAirports';
        this.name = 'Comeback airport';
        this.urlEnabled = props.urlFilters.returnAirports && props.urlFilters.returnAirports.length !== 0;
    }

    selectAirport(code, e) {
        this.props.returnAirportSelected(code);
    }

    renderAirportList() {
        let list = [];
        for (const key of Object.keys(this.props.returnAirports)) {
            list.push(this.renderAirport(key, this.props.returnAirports[key]))
        }

        return list;
    }

    renderAirport(code, airport) {
        return (
            <div className="form-check" key={code}>
                <label className="form-check-label">
                    <input
                        checked={this.props.selected.indexOf(code) !== -1}
                        onChange={this.selectAirport.bind(this, code)}
                        className="form-check-input" type="checkbox" value={code}/>
                    <small>{airport.title}</small>
                </label>
                <span className="tag badge badge-warning float-right"
                      {...this.priceFormatter.format(airport.price)}
                ></span>
            </div>
        );
    }

    render() {
        if (Object.keys(this.props.returnAirports).length <= 1) {
            return null;
        }
        this.priceFormatter = new PriceFormatter(this.props.parameters['price-format']);

        const translator = new Translator(this.props.translator, DOMAIN);

        return (
            <div>
                <div className={`card-body ${this.isApplied() ? `filter-applied` : null}`}>
                    <div className="font-weight-bold mb-2">{translator.trans(this.name)}</div>
                    {this.renderClearFilterButton()}
                    {this.renderAirportList()}
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        returnAirportSelected,
        registerAppliedFilter,
        clearFilter
    }, dispatch);
}

function mapStateToProps(state) {
    return {
        translator: state.TranslationsReducer.translations,
        returnAirports: state.ReturnAirportsFilterReducer.airports,
        selected: state.ReturnAirportsFilterReducer.selected,
        parameters: state.ParametersReducer.parameters,
        urlFilters: state.SocketReducer.urlFilters,
        appliedFilters: state.FilterGroupsReducer
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturnAirportBlock);



// WEBPACK FOOTER //
// ./src/components/filters/ReturnAirportBlock.js